import type { FunctionComponent, ReactNode } from 'react';

import { Icon, type IconicNames, type IconicTypes } from '@/atoms/Icons';

export const ButtonContent: FunctionComponent<{
  showLabel: boolean;
  label?: string;
  children?: ReactNode;
  icon?: IconicNames;
  iconType?: IconicTypes;
}> = ({ showLabel, label, children, icon, iconType }) => {
  return (
    <span className="flex items-center justify-center gap-x-8 w-full">
      {showLabel ? label : <span className="sr-only">{label}</span>}
      {children}
      {icon && <Icon width="24px" name={icon} type={iconType} />}
    </span>
  );
};
